import { Injectable } from '@angular/core';
import { OtiService } from '@sp/oti-snippet';
import { filter, first } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

import { UserService } from './user.service';

/* istanbul ignore next */
@Injectable()
export class AnalyticsService {
  constructor(private userService: UserService) {}

  async init(orderId: string): Promise<void> {
    if (environment.analytics.enabled) {
      const user = await this.userService
        .getCurrentUserObservable()
        .pipe(
          filter((u) => !!u.name),
          first(),
        )
        .toPromise();

      const userName = user!.name?.toUpperCase();
      const config = {
        app_id: 'abalyst-selection-tool',
        ot_key: environment.analytics.oneTrust.apiKey,
        prod_domain: environment.analytics.oneTrust.productionUrl,
        pendo_key: environment.analytics.pendo.apiKey,
        pendo_url:
          'https://content.usage.apps.compumark.com/agent/static/' +
          environment.analytics.pendo.apiKey +
          '/pendo.js',
        pendo_visitor_url:
          environment.backendBaseUrl + '/pendo/visitor/agent/value?create=true',
        pendo_dnp_url:
          environment.backendBaseUrl +
          `/pendo/visitor/pendo/value/${userName}/donotprocess`,
        pendo_metadata_url:
          environment.backendBaseUrl +
          `/pendo/visitor/custom/value/${userName}/APPID_targetingcookies`,
        pendo_details: {
          visitor: {
            id: userName,
            name: userName,
            ast_order: orderId,
          },
          account: {
            id: 'bla-trial',
          },
        },
        pendo_visitor_payload: [
          {
            visitorId: userName,
            values: {
              name: userName,
              ast_order: orderId,
            },
          },
        ],
      };
      const otiService = new OtiService();
      otiService.initialize(config);
    }
  }
}
